import React, { FC } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { TransactionsDateColumnApprovedTooltip } from './TransactionsDateColumnApprovedTooltip';
import { CircleCheckIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const TransactionsDateColumnApproved: FC<{ approvedBy: string | null; approvedAt: Date | null }> = ({
  approvedAt,
  approvedBy,
}) => {
  const { t } = useTranslation();

  // Show detailed tooltip only if we have approval info, otherwise show simple "Confirmed"
  const tooltipContent =
    approvedAt && approvedBy ? (
      <TransactionsDateColumnApprovedTooltip approvedAt={approvedAt} approvedBy={approvedBy} />
    ) : (
      t('Confirmed')
    );

  return (
    <OverlayTrigger placement="top" overlay={<Tooltip>{tooltipContent}</Tooltip>}>
      <CircleCheckIcon size={14} color="green" />
    </OverlayTrigger>
  );
};
